
import { observable, action, IObservableArray } from "mobx";
import Localization from "./localization";
import ViewState from "./viewState";
import LegalStore from "./legalStore";
import ProfileStore from "./profileStore";
import OpportunityStore from "./opportunityStore";
import EducationsStore from "./educationsStore";
import Templates from "../models/templates";
import Fetcher, { IHttpResult } from "../utils/fetcher";
import { copyArray } from "../utils/data";
import { Registration } from "../models/registration";
import { ContactRequest } from "../models/help";
import { BusyEvent, SkillSmartProduct } from "../models/enums";
import { Auth } from "../utils/auth";
import DCIAStore from "./dciaStore";
import HudsonYardsStore from "./hudsonYardsStore";
import { HelpRequest, HelpTopicRequest, HelpTopic, ExistingHelp } from "../models/integratedHelp";

/*
** The SeekerStore is the topmost store that manages the collection of data for the seeker site
** and serves as the caller to all service methods in the application.  It is comprised of other
** function-specific stores that have ownership of key elements like profile, opportunities, etc.
*/
export default class SeekerStore {
  @observable localization: Localization;
  @observable profileStore: ProfileStore;
  @observable opportunityStore: OpportunityStore;
  @observable dciaStore: DCIAStore;
  @observable hyStore: HudsonYardsStore;
  @observable legal: LegalStore;
  @observable educationStore:EducationsStore;
  @observable viewState: ViewState;
  @observable templates: Templates;
  languageCallbacks = [];
  @observable initCt: number;
  @observable lookUpValues: Array<Registration>;
  initCallback: () => void = null;
  readonly appName: string = "seeker2";
  @observable helpTopics: Array<HelpTopic>;
  @observable existingHelpTopics: Array<ExistingHelp>;
  @observable gettingHelpFor: Array<string>;

  constructor() {
    this.initCt = 0;
    this.addBusy();
    this.viewState = new ViewState(this);
    this.initCallback = this.viewState.initPath;
    this.localization = new Localization(this);
    this.profileStore = new ProfileStore(this);
    this.dciaStore = new DCIAStore(this);
    this.hyStore = new HudsonYardsStore(this);
    this.legal = new LegalStore(this);
    this.educationStore = new EducationsStore(this);
    this.opportunityStore = new OpportunityStore(this);
    this.initTemplates();
    this.clearBusy();
    this.helpTopics = new Array<any>();
    this.existingHelpTopics = new Array<ExistingHelp>();
    this.gettingHelpFor = new Array<string>();
  }
  get isInitializing(): boolean {
    return this.initCt > 0;
  }
  @action addBusy = (): void => {
    this.initCt++;
  }
  @action clearBusy = (): void => {
    this.initCt--;
    if (this.initCt < 0) {
      this.initCt = 0;
    }
    if (this.initCt === 0 && this.initCallback) {
      this.initCallback();
      this.initCallback = null;
    }
  }
  initTemplates(): void {
    Fetcher.get("api/lookups/templates", action((t: Templates): void => {
      this.templates = t;
    }));
  }
  /*submitHelpRequest = (request: ContactRequest, cb: (resp: boolean) => void): void => {
    this.viewState.setBusyBit(BusyEvent.SubmittingHelp);
    Fetcher.postWithResult("api/help/contact", request, (result: IHttpResult): void => {
      this.viewState.clearBusyBit(BusyEvent.SubmittingHelp);
      cb(result.ok);
    });
  }*/
  @action submitHelpRequest(message: string, email?: string, cb?: (success: boolean) => void): void {
    this.viewState.setBusyBit(BusyEvent.SubmittingHelp);
    const req: HelpRequest = new HelpRequest(SkillSmartProduct.Seeker);
    req.message = message;
    req.email = email;
    if (req.email.length === 0 && !Auth.isAuthenticated) {
      this.viewState.setShowSnackbar(true, "Error: Email is required. Please enter email and try again.")
      cb(false);
      return;
    }
    if (!Auth.isAuthenticated) {
      Fetcher.postWithResult("api/integrated-help/anon-request", req, action((resp: IHttpResult): void => {
        this.viewState.clearBusyBit(BusyEvent.SubmittingHelp);
        cb(resp.ok);
      }));
    } else {
      Fetcher.postWithResult("api/integrated-help", req, action((resp: IHttpResult): void => {
        this.viewState.clearBusyBit(BusyEvent.SubmittingHelp);
        cb(resp.ok);
      }));
    }
   
  }
  @action getHelpTopics(): void {
    const req: HelpTopicRequest = new HelpTopicRequest(SkillSmartProduct.Seeker);
    req.language = this.localization.language;
    const ndx: number = this.existingHelpTopics.findIndex((eh: ExistingHelp): boolean => {
      return eh.view === req.view;
    });
    if (ndx !== -1) {
      this.helpTopics = this.existingHelpTopics[ndx].topics;
      return;
    }
    if (this.gettingHelpFor.indexOf(req.view) !== -1) {
      return;
    }
    this.gettingHelpFor.push(req.view);
    Fetcher.postWithData("api/integrated-help/topics", req, action((topics: Array<HelpTopic>): void => {
      if (topics) {
        const existing: ExistingHelp = new ExistingHelp();
        existing.view = req.view;
        copyArray(topics, existing.topics, (ht: HelpTopic) => { return new HelpTopic(ht); });
        this.existingHelpTopics.push(existing);
        this.helpTopics = existing.topics;
        (this.gettingHelpFor as IObservableArray<string>).remove(req.view);
      }
    }));
  }
  @action remapHelpTopicsForLanguage(): void {
    this.existingHelpTopics.map((eh: ExistingHelp): void => {
      eh.topics = new Array<HelpTopic>();
      const req: HelpTopicRequest = new HelpTopicRequest(SkillSmartProduct.Seeker);
      req.view = eh.view;
      req.language = this.localization.language;
      Fetcher.postWithData("api/integrated-help/topics", req, action((topics: Array<HelpTopic>): void => {
        copyArray(topics, eh.topics, (ht: HelpTopic) => { return new HelpTopic(ht); });
      }));
    })
  }
}


// WEBPACK FOOTER //
// ./src/stores/seekerStore.ts